// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"99fafa6a","226":"08752380","453":"121232bb"}[chunkId] + ".chunk.js";
};